import { matchPath } from 'react-router';

import { External, Route } from 'src/shared/route';

const ALLOWED_HOSTS = /^(https:\/\/(\w+[.])*hover.to$)/;
const QUERY_STRING_REDIRECT_PARAMETER = 'redirect_to';

const getRedirectParam = (url: string) =>
  new URL('', url).searchParams.get(QUERY_STRING_REDIRECT_PARAMETER);

const validateRedirectUrl = (redirect: string, url: string) => {
  const { origin } = new URL(url);
  const redirectOrigin = new URL(redirect, url).origin;

  return origin === redirectOrigin || ALLOWED_HOSTS.test(redirectOrigin);
};

const baseUrlToRedirectUrl = (
  url: string,
  defaultRedirectPath: string = External.START.path,
) => {
  const redirectParam = getRedirectParam(url);
  const redirectTo =
    redirectParam && validateRedirectUrl(redirectParam, url)
      ? redirectParam
      : defaultRedirectPath;

  return new URL(redirectTo, url).href;
};

const baseUrlToLoginSuccessUrl = (url: string) => {
  const redirectTo = getRedirectParam(url);
  const successUrl = new URL(Route.LOGIN_SSO_SUCCESS.path, url);

  if (redirectTo) {
    successUrl.searchParams.append(QUERY_STRING_REDIRECT_PARAMETER, redirectTo);
  }

  return successUrl.toString();
};

const preserveQueryParameters = (newUrl: string, currentUrl: string) =>
  newUrl + new URL(currentUrl).search;

/**
 * Normalize URL `pathname` by stripping the trailing slash
 *
 * @param pathname pathname to normalize
 */
const normalizePathname = (pathname: string) => pathname.replace(/\/+$/, '');

const getRoute = (pathname: string) =>
  Object.values(Route).find(({ path }) => {
    const matches = matchPath(pathname, { path, strict: true, exact: true });
    return !!matches;
  });

export {
  QUERY_STRING_REDIRECT_PARAMETER,
  baseUrlToRedirectUrl,
  baseUrlToLoginSuccessUrl,
  getRoute,
  normalizePathname,
  preserveQueryParameters,
};
